goog.provide("shadow.js.shim.module$$mui$material$Accordion$default");
shadow.js.shim.module$$mui$material$Accordion$default = shadow.js.shim.module$$mui$material$Accordion.default;
